
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 73 21","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_195_25179)"}},[_c('path',{attrs:{"d":"M10.35 19.14c-1.093.195-2.204.253-3.353.41L3.491 9.08V20c-1.091.117-2.087.273-3.122.43v-20h2.912l3.984 11.347V.428h3.084V19.14zm6.033-11.387c1.188 0 3.008-.059 4.1-.059v3.125c-1.36 0-2.95 0-4.1.059v4.648c1.801-.117 3.602-.273 5.421-.332v3.008l-8.486.683V.428h8.486v3.125h-5.42v4.2zm16.819-4.2h-3.18v14.375c-1.034 0-2.069 0-3.065.04V3.554h-3.18V.428h9.425v3.126zm4.98 3.985h4.195v3.125h-4.195v7.09h-3.007V.428h8.563v3.125h-5.556v3.985zm10.536 7.48c1.743.04 3.505.176 5.21.274v3.086c-2.739-.176-5.478-.352-8.275-.41V.428h3.065v14.59zm7.796 3.575c.977.058 2.012.117 3.008.234V.428h-3.008v18.165zM72.95.428L69.061 9.94 72.95 20.43c-1.15-.157-2.299-.372-3.448-.567l-2.203-5.781-2.241 5.312c-1.111-.195-2.184-.254-3.295-.41l3.946-9.16L62.146.428h3.295l2.011 5.254L69.598.428h3.352z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_195_25179"}},[_c('path',{attrs:{"fill":"currentColor","transform":"translate(.37 .428)","d":"M0 0h72.581v20H0z"}})])])])
          )
        }
      }
    